import React from 'react'

type AmplitudeEvent = {
  analysisName?: string
  eventNameSuffix?: string
}

const AmplitudeContext = React.createContext<AmplitudeEvent>(
  undefined as unknown as AmplitudeEvent,
)

export type AmplitudeProviderProps = React.PropsWithChildren<AmplitudeEvent>

// contextは祖先からしか継承できないため、自分自身がAmplitudeProviderをレンダーする
// コンポーネントの中でuseLogEvent()を呼んでも、その戻り値のlogEventはこの
// Providerの子孫にならず withSuffix/withAnalysisName は効かない。そのコンポーネント
// 自身がログを送る場合は、Providerを呼び出し元（祖先）に移すか、ログを送る側を
// 別の子コンポーネントに分離してProviderの子孫にすること
export const AmplitudeProvider = ({
  children,
  ...rest
}: AmplitudeProviderProps) => (
  <AmplitudeContext.Provider value={rest}>{children}</AmplitudeContext.Provider>
)

export const useAmplitudeContext = () => {
  const store = React.useContext(AmplitudeContext)

  return store
}
